import React from 'react';

import Right from '@material-ui/icons/ChevronRightRounded';

import Button from '../../../../components/Button';

export interface IArrowProps {
  onClick?: any;
}

export const ArrowRight = ({ onClick }: IArrowProps) => (
  <Button variant="text" className="arrow-right" onClick={onClick}>
    <Right color="primary" fontSize="large" />
  </Button>
);
